import Subtitle from "library/Atoms/Subtitle";
import { PropTypes } from "prop-types";

const BookingFormLayout = ({
  settingsTitleSection,
  settingsFormSection,
  customerTitleSection,
  customerFormSection,
  cardTitleSection,
  cardFormSection,
  orderDetailsSection,
  controlsSection,
  shouldShowCardSections,
}) => (
  <>
    <div className="d-flex flex-wrap justify-content-between align-items-start col-12 px-0">
      <div className="d-flex flex-column col-12 col-md-6 mt-2 px-0 pl-md-0 pr-md-4 gap-3">
        <div>
          <Subtitle>{settingsTitleSection}</Subtitle>

          {settingsFormSection}
        </div>

        <div>
          <Subtitle>{customerTitleSection}</Subtitle>

          {customerFormSection}
        </div>

        {shouldShowCardSections && (
          <div>
            <Subtitle>{cardTitleSection}</Subtitle>

            {cardFormSection}
          </div>
        )}
      </div>

      {orderDetailsSection}
    </div>

    {controlsSection}
  </>
);

BookingFormLayout.propTypes = {
  settingsTitleSection: PropTypes.node.isRequired,
  settingsFormSection: PropTypes.node.isRequired,
  customerTitleSection: PropTypes.node.isRequired,
  customerFormSection: PropTypes.node.isRequired,
  cardTitleSection: PropTypes.node.isRequired,
  cardFormSection: PropTypes.node.isRequired,
  orderDetailsSection: PropTypes.node.isRequired,
  controlsSection: PropTypes.node.isRequired,
  shouldShowCardSections: PropTypes.bool.isRequired,
};

export default BookingFormLayout;
